import { z } from 'zod';

export const TrialStatusSchema = z.object({
  isTrial: z.boolean(),
  daysRemaining: z.number(),
  trialEndsAt: z.string().nullable(),
  isExpired: z.boolean(),
  subscriptionStatus: z.string(),
});
export type TrialStatus = z.infer<typeof TrialStatusSchema>;

export const StartTrialInputSchema = z.object({
  trialDays: z.number().min(1).max(90).default(14),
});
export type StartTrialInput = z.infer<typeof StartTrialInputSchema>;

export const DunningStatusSchema = z.object({
  expiredCount: z.number(),
  processedAt: z.string(),
});
export type DunningStatus = z.infer<typeof DunningStatusSchema>;
